import { DateTime } from 'luxon';
import * as showdown from 'showdown';
import axios from 'smg/axios';
import { HandleRequestError } from 'smg/errors';
import { G } from 'smg/querystring';
import * as models from 'smg/models';
import * as strings from 'smg/strings';

declare interface blogPost extends models.BlogPost {
    lastPublished?: string;
}

declare interface blogPostResp {
    blogPost: blogPost;
}

if (document.body.id === 'discover-preview') {
    void main();
}

export default async function main() {
    const id = G().Get('id');
    const version = G().Get('v');

    const blogPost = await axios.get<blogPostResp>(`/blog-posts/${id ?? ''}`, {
        params: {
            'q': version ? `version:${version}` : 'latest:yes',
            'data': 'title,slug,author,markdown,published,featured,unlisted,tags,category,created,validFrom,version,lastPublished',
        },
    }).then(resp => resp.data.blogPost).
        catch(err => {
            HandleRequestError(err);
            throw err;
        });

    let markdown = blogPost.markdown ?? '';
    const markdownTitle = /^\s*# (.*)$/m.exec(markdown);
    if (markdownTitle) {
        markdown = strings.TrimPrefix(markdown, markdownTitle[0]).trim();
    }

    const $title = document.querySelector('main h1') as HTMLElement;
    $title.textContent = markdownTitle?.[1] || blogPost.title || '';

    const $content = document.querySelector('#content') as HTMLElement;
    const converter = new showdown.Converter();
    $content.innerHTML = converter.makeHtml(markdown);

    const $date = document.querySelector('#date-published') as HTMLElement;
    $date.textContent = DateTime.fromISO(blogPost.validFrom ?? '').toLocaleString(DateTime.DATE_FULL);
}
